import React from "react";

class Welcome extends React.Component {
    render() {
        return <h1 className="text-white">Ingenear</h1>;
    }
}

export default Welcome;
